module.exports = __webpack_public_path__ + "img/new-treatment-modal-mobile-fr.86e4a6ed.jpg";